import { createFileRoute, useParams } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { TutorPage } from "@/components/tutor/tutor-page";
import { requireRole } from "@/lib/session";

export const Route = createFileRoute("/learner/tutor/$threadId")({
  ssr: false,
  beforeLoad: () => requireRole("learner"),
  head: () => ({ meta: [{ title: "MAKAI Tutor · MAKAI" }] }),
  component: Page,
});

function Page() {
  const { threadId } = useParams({ from: "/learner/tutor/$threadId" });
  return (
    <AppShell role="learner" title="MAKAI Tutor" subtitle="Your personal learning companion">
      <TutorPage role="learner" threadId={threadId} />
    </AppShell>
  );
}
